<template>
  <div class="bindDetails">
    <div class="bindField">
      <div class="select">
        <van-dropdown-menu>
          <van-dropdown-item v-model="value1" :options="option1" @change="onChange" />
        </van-dropdown-menu>
      </div>
      <van-field
        v-model="value"
        class="user"
        :placeholder="'请'+placeholder+'名称'"
        maxlength="20"
        @input.native="onUser"
      />
    </div>
    <div class="IDNumber">
      <van-field
        v-model="IDNumber"
        placeholder="请输入身份证号"
        maxlength="18"
        @input.native="onIdNumber"
      />
    </div>
    <footer class="footer">
      <van-button type="primary" :disabled="rules" @click.native="onSubmit">完成</van-button>
      <van-button type="default" @click.native="onLaterBinding">稍后绑定</van-button>
      <!-- <van-button type="default" @click.native="onForwarding">跳转转发</van-button> -->
    </footer>
  </div>
</template>
<script>
import Storage from '@/tools/storage.js'
export default {
  name: 'bindDetails',
  data() {
    return {
      value: '',
      IDNumber: '',
      value1: 1,
      showPicker: false,
      option1: [
        { text: '绑定本人', value: 1 },
        { text: '绑定丈夫', value: 2 },
        { text: '绑定妻子', value: 3 },
        { text: '绑定父亲', value: 4 },
        { text: '绑定母亲', value: 5 },
        { text: '绑定儿子', value: 6 },
        { text: '绑定女儿', value: 7 },
        { text: '绑定其他', value: 8 }
      ],
      rules: true,
      placeholder: '绑定本人'
    }
  },
  methods: {
    onUser() {
      if (this.value.length != 0 && this.IDNumber.length == 18) {
        this.rules = false
      }
    },
    onIdNumber() {
      if (this.value.length != 0 && this.IDNumber.length == 18) {
        this.rules = false
      }
    },
    onSubmit() {
      let Chinese = /\p{Unified_Ideograph}/gu
      if (Chinese.test(this.value)) {
        let params = {
          name: this.value,
          idCard: this.IDNumber,
          phone: Storage.get('phone'),
          institution_id: '13000003',
          kinship: this.value1
        }
        this.$emit('getBind', params)
      } else {
        alert('请输入正确的姓名')
      }
    },
    onLaterBinding() {
      this.$emit('getLater')
    },
    onForwarding() {
      this.$router.push({ path: '/remoteList' })
    },
    onChange(val) {
      for (let item of this.option1) {
        if (item.value == val) {
          this.placeholder = item.text
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bindDetails {
  width: 90%;
  margin: 0 auto;
}
</style>


